module.exports = __webpack_public_path__ + "img/dog.c7fd4d5d.svg";